<template>
  <div class="flex flex-col w-screen">
    <CarouselView />
    <RecentNews :info="recentNews" />
    <MiddleMenu :info="middleMenu" />
    <SpecialColumn :info="specialColumn" />
    <VideoColumn :info="videoColumn" />
    <LearningResource :info="learningResource" />
    <ResourcePlatform :info="resourcePlatform" :isIndex="isIndex" />
    <Footer :linkList="friendshipLink" :info="footInfo" />
  </div>
</template>

<script>
import MobileMenu from "./components/MobileMenu.vue";
import CarouselView from "./components/CarouselView.vue";
import RecentNews from "./components/RecentNews.vue";
import MiddleMenu from "./components/MiddleMenu.vue";
import SpecialColumn from "./components/SpecialColumn.vue";
import VideoColumn from "./components/VideoColumn.vue";
import LearningResource from "./components/LearningResource.vue";
import ResourcePlatform from "./components/ResourcePlatform.vue";
import Footer from "./components/Footer.vue";
import "./filters/index.js";

import { getFriendshipLink } from "./api/resource.js";
import { getNotLogIn, getIndexNews } from "./api/column.js";
import { getColumnInfo } from "./utils/formatResData.js";
import { array_ } from "./utils/index.js";

export default {
  components: {
    MobileMenu, // 移动端菜单
    CarouselView, // 轮播图
    RecentNews, // 最近新闻
    MiddleMenu, // 中间菜单+页面
    SpecialColumn, // 专栏
    VideoColumn, // 视频
    LearningResource, // 教学资源
    ResourcePlatform, // 资源平台
    Footer, // 底部
  },
  data() {
    return {
      isIndex: true,
      recentNews: {}, // 最近新闻
      middleMenu: {}, // 中间菜单
      specialColumn: {}, // 专栏
      videoColumn: {}, // 视频
      learningResource: {}, // 教学资源
      resourcePlatform: [], // 资源平台
      friendshipLink: [], // 友情链接
      footInfo: {}, // 底部信息
    };
  },
  methods: {
    // 设定数据
    setColumnInfo(columnInfo) {
      this.recentNews = columnInfo.recentNews;
      this.middleMenu = columnInfo.middleMenu;
      this.specialColumn = columnInfo.specialColumn;
      this.videoColumn = columnInfo.videoColumn;
      this.learningResource = columnInfo.learningResource;
    },
    // 获取信息
    async getPageInfo() {
      // if (this.$store.state.isLogin) {
      //   const pageInfo = await getIndexNews();
      //   const columnInfo = getColumnInfo(pageInfo);
      //   this.setColumnInfo(columnInfo);
      // } else {
      //   const pageInfo = await getNotLogIn();
      //   const columnInfo = getColumnInfo(pageInfo);
      //   this.setColumnInfo(columnInfo);
      // }
        const pageInfo = await getIndexNews();
        const columnInfo = getColumnInfo(pageInfo);
        this.setColumnInfo(columnInfo);
    },
    // 获取资源平台
    async getFriendshipLinkInfo() {
      const data = await getFriendshipLink();
      this.resourcePlatform = array_(data?.outer);
      this.friendshipLink = array_(data?.res);
      this.footInfo = array_(data?.top)[0] || {};
    },
  },
  created() {
    this.getPageInfo(); // 获取界面信息
    this.getFriendshipLinkInfo(); // 获取资源平台
  },
};
</script>
